import {createSlice} from '@reduxjs/toolkit'

const initialGroupState = {
  group: null,
  groupsDropdown: [],
}

export const GroupSlices = createSlice({
  name: 'groups',
  initialState: initialGroupState,
  reducers: {
    group: (state, action) => {
      state.group = action.payload.group
    },
    groupList: (state, action) => {
      state.groupsDropdown = action.payload.groups
    },
    resetGroup: (state) => {
      state.group = null
    },
  },
})
